import { DatabaseX } from 'lucide-react'

import { useSystemStatus } from '@/features/overview/system-status'
import { IN_MEMORY_PROVIDER, noDatabaseNotice } from '@/features/shell/database-mode'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * Says in the header when the server keeps its data in memory. Shown only when the status endpoint confirms
 * it: nothing while loading or on error, so it never guesses. Focusable, so the explanation is reachable
 * by keyboard as well as by hover.
 */
export function DatabaseBadge({ environment }: { environment: string }) {
  const { data } = useSystemStatus()
  if (data?.database.provider !== IN_MEMORY_PROVIDER) return null
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" tabIndex={0} className="font-mono text-[11px] uppercase">
          <DatabaseX aria-hidden />
          No database
        </Badge>
      </TooltipTrigger>
      <TooltipContent side="bottom">{noDatabaseNotice(environment)}</TooltipContent>
    </Tooltip>
  )
}
